import JurisdictionTotal from './jurisdictionTotal';
import Vendor from './vendor';

export default class Invoice {
  constructor(public vendor: Vendor,
    public jurisdictionTotals: JurisdictionTotal[],
    public totalRequestCount: number,
    public totalInvoiceAmount: number) { }

  static createFromRequest(request: any): Invoice {
    const vendor = Vendor.createFromRequest(request);
    const jurisdictionTotals = new Array<JurisdictionTotal>();

    for (const jurisdictionTotal of request.jurisdictions) {
      jurisdictionTotals.push(JurisdictionTotal.createFromRequest(jurisdictionTotal));
    }

    return new Invoice(vendor,
      jurisdictionTotals,
      request.source.totalRequests,
      request.source.totalInvoiceAmount);
  }
}



// WEBPACK FOOTER //
// ./src/models/invoice.ts